// Configuration for API keys and endpoints

// Direct use of environment variables without conditional checks
const config = {
  // Gemini API key - always use the environment variable
  geminiApiKey: process.env.REACT_APP_GEMINI_API_KEY,

  // OpenRouter API key
  openRouterApiKey: process.env.REACT_APP_OPENROUTER_API_KEY,
  
  // API endpoints
  apiEndpoints: {
    // Single Gemini API endpoint for both text and image
    geminiApi: process.env.REACT_APP_GEMINI_API_ENDPOINT,
    // OpenRouter API endpoint
    openRouterApi: 'https://openrouter.ai/api/v1/chat/completions'
  }
};

export default config;